"use client"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { useEffect, useState } from "react"
import { BookOpen, UserCircle, Settings } from "lucide-react"
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  useSidebar,
} from "@/components/ui/sidebar"

// Centralized nav items for student routes
const links = [
  { label: "My Rotations", href: "/student/bookings", icon: BookOpen },
  { label: "My Profile", href: "/student/profile", icon: UserCircle },
  { label: "Settings", href: "/student/settings", icon: Settings },
]

export function StudentSidebar() {
  const pathname = usePathname()
  const { isMobile, setOpenMobile } = useSidebar()
  const [isHydrated, setIsHydrated] = useState(false)

  useEffect(() => {
    setIsHydrated(true)
  }, [])

  const handleLinkClick = () => {
    if (isMobile) setOpenMobile(false)
  }

  return (
    <Sidebar collapsible="icon" className="border-r border-slate-200">
      <SidebarHeader className="border-b border-slate-200">
        <div className="flex flex-col gap-1 px-2">
          <h2 className="text-lg font-bold text-slate-900">Student Portal</h2>
          <p className="text-xs text-slate-600">Manage your rotations</p>
        </div>
      </SidebarHeader>

      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel className="text-slate-700">Student</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {isHydrated &&
                links.map((link) => {
                  const active = pathname === link.href || pathname.startsWith(link.href + "/")
                  const Icon = link.icon

                  return (
                    <SidebarMenuItem key={link.href}>
                      <SidebarMenuButton
                        asChild
                        isActive={active}
                        className={`transition-colors ${
                          active ? "bg-blue-600 text-white shadow-sm hover:bg-blue-700" : "text-slate-700 hover:bg-slate-100"
                        }`}
                        title={link.label}
                      >
                        <Link href={link.href} onClick={handleLinkClick}>
                          <Icon />
                          <span>{link.label}</span>
                        </Link>
                      </SidebarMenuButton>
                    </SidebarMenuItem>
                  )
                })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
    </Sidebar>
  )
}

export default StudentSidebar
